<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Reservation, contact + address:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"><i class="bi bi-trash-fill remove-block-icon"></i></a>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'Res1Image')"
            [blockData]="block.variables?.Res1Image ?? ''"
            [placeholder]="image1Placeholder"
            variable="Res1Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'Res2Image')"
            [blockData]="block.variables?.Res2Image ?? ''"
            [placeholder]="image2Placeholder"
            variable="Res2Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'Res1ImageHref')"
            [blockData]="block.variables?.Res1ImageHref ?? ''"
            [placeholder]="image1HrefPlaceholder"
            variable="Res1ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'Res1ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.Res1ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'Res2ImageHref')"
            [blockData]="block.variables?.Res2ImageHref ?? ''"
            [placeholder]="image2HrefPlaceholder"
            variable="Res2ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'Res2ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.Res2ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'Res1ImageAlt')"
            [blockData]="block.variables?.Res1ImageAlt ?? ''"
            [placeholder]="image1AltPlaceholder"
            variable="Res1ImageAlt"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'Res2ImageAlt')"
            [blockData]="block.variables?.Res2ImageAlt ?? ''"
            [placeholder]="image2AltPlaceholder"
            variable="Res2ImageAlt"
          ></app-block-text>
        </div>
  
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'ResPropertyName')"
            [blockData]="block.variables?.ResPropertyName ?? ''"
            [placeholder]="namePlaceholder"
            variable="ResPropertyName"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'ResAddress')"
            [blockData]="block.variables?.ResAddress ?? ''"
            [placeholder]="addressPlaceholder"
            variable="ResPropertyName"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'ResTelephone')"
            [blockData]="block.variables?.ResTelephone ?? ''"
            [placeholder]="telephonePlaceholder"
            variable="ResTelephone"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="25"
            (handleOnChange)="onChange($event, 'ResCheckIn')"
            [blockData]="block.variables?.ResCheckIn ?? ''"
            [placeholder]="checkInPlaceholder"
            variable="ResCheckIn"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="25"
            (handleOnChange)="onChange($event, 'ResCheckOut')"
            [blockData]="block.variables?.ResCheckOut ?? ''"
            [placeholder]="checkOutPlaceholder"
            variable="ResCheckOut"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-6" *ngIf="block.variables?.Res1Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.Res1ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.Res1Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.Res1ImageAlt)"
            /></a>
          </div>
          <div class="col-6" *ngIf="block.variables?.Res2Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.Res2ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.Res2Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.Res2ImageAlt)"
            /></a>
          </div>
        </div>
        <div class="row text-left">
          <div
            class="col-12"
            [innerHTML]="$safeNavigationMigration(block.variables?.ResPropertyName)"
          ></div>
          <div class="col-12" [innerHTML]="$safeNavigationMigration(block.variables?.ResAddress)"></div>
          <div class="col-12" [innerHTML]="$safeNavigationMigration(block.variables?.ResTelephone)"></div>
          <div class="row">
            <div class="col-6" *ngIf="block.variables?.ResCheckIn">
              <p
                class="mr-3"
                [innerHTML]="'Check In: ' + $safeNavigationMigration(block.variables?.ResCheckIn)"
              ></p>
            </div>
            <div class="col-6" *ngIf="block.variables?.ResCheckOut">
              <p [innerHTML]="'Check Out: ' + $safeNavigationMigration(block.variables?.ResCheckOut)"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
